import cookie from 'cookie';

import { isPwa } from '@r1-frontend/shared/helpers/isPwa';

export type TDataLayerPushArgument<TEcommerceProps = {}> = {
    event: string,
    ecommerce?: TEcommerceProps,
    category: string,
    action: string,
    label?: string,
    ABNtest?: string,
    uid?: number,
}

type TDataLayerWindow = Window & typeof globalThis & {
    dataLayer: Array<unknown>,
}

/**
 * Отправка события в GA
 * @example
 * dataLayerPush({event: 'UAevent', category: 'sale', action: 'get gift'});
 */
export const dataLayerPush = <TEcommerceProps = {}>({ label = '', ...params }: TDataLayerPushArgument<TEcommerceProps>): void => {
    if (typeof window === 'undefined') {
        throw new Error('The dataLayerPush function must not be used on the backend side.');
    }

    if (!('dataLayer' in window)) {
        (window as TDataLayerWindow).dataLayer = [];
    }

    window.dataLayer.push({
        ...params,
        'ABNtest': cookie.parse(document.cookie)['abn_variant'],
        'isPwa': isPwa(),
        label,
    });

    return;
};
